export const popularModels = [1951, 2951, 3728, 3087, 4196, 1614];
